import Client from './client';

export default class CustomsDetails extends Client {
  constructor(opts) {
    let options = opts;

    if (typeof opts === 'string') {
      options = { host: opts }; // convert host string to options object
    }

    options.serviceName = 'API Internal';

    super(options);
  }

  post(organization, options = {}) {
    return this.makeRequest(`${this.host}/${organization}/harmonization/customs/details`, {
      ...options,
       method: 'POST',
    });
  }

}
